import { lsRemoveAll } from '@/utils/localStorageController'
import { SECURITY_COOKIE_NAME, LOGIN_COOKIE_NAME } from '@/services/securityCookieHandler'

export default {
  methods: {
    logoutUser () {
      this.$loader.show(' ')
      this.$mvcRequest.post('user/logout')
        .finally(() => {
          lsRemoveAll()
          this.$cookies.remove(SECURITY_COOKIE_NAME)
          this.$cookies.remove(LOGIN_COOKIE_NAME)
          window.location.reload()
        })
    }
  }
}
